export function MHAddParentToList(anObj, parentList) {
  var aParent = anObj.GetParent();
  if (aParent != null && parentList.indexOf(aParent) == -1) parentList.push(aParent);
}
